export default "__VITE_ASSET__Q43hCyc___"